<template>
    <v-card width="600" class="mx-auto ma-4">
        <v-card-title>
            Enheter
        </v-card-title>
        <v-card-text>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Namn</th>
                            <th class="text-left">Typ</th>
                            <th class="text-left">Besättning</th>
                            <th class="text-left">Nästa service</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="unit in units" :key="unit._key">
                            <td>{{ unit.name }}</td>
                            <td>{{ unit.type }}</td>
                            <td>{{ unit.minimumPeople }}–{{ unit.maximumPeople }}</td>
                            <td>{{ new Date(unit.nextService.seconds*1000).humanDate() }}</td>
                            <td>
                                <v-icon>mdi-pencil-outline</v-icon>
                            </td>
                            <td>
                                <v-icon>mdi-trash-can-outline</v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card-text>
        <v-divider />
        <v-card-actions v-if="showAddButton" class="pa-2">
            <v-spacer />
            <v-btn>Lägg till enhet</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "UnitList",
    props: {
        'showAddButton': Boolean,
    },
    mounted() {
        console.log('stationId', this.$stationId)
    },
    firestore () {
        return {
            // Collection
            units: window.db.collection('stations').doc(this.$stationId).collection('units'),
        }
    },
}
</script>

<style>

</style>